module.exports = __webpack_public_path__ + "images/65504776f589d6ec1be0ae11f6112299.png";